/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import React from 'react';
import { css } from '@emotion/react';
import TextBlock from 'component/common/block/text-block';
import ImageBlock from '@component/common/block/image-block';
import { IBlock } from '@datatype/type';
import BoxBlock from '@component/common/block/box-block';
import { useClicker } from '@hook/common/useEvent';

interface IProps {
  src: string;
  alt: string;
  text: string;
  design: Pick<IBlock['design'], 'box' | 'text' | 'image'>;
  click?: IBlock['click'];
}

// const Wrapper = styled(BoxBlock)<Pick<IProps, 'design'>>``;

const ImageTextBlock: React.FC<IProps> = ({ src, alt, text, design, click }) => {
  const clicker = useClicker(click?.handler, click?.delay, click?.mode);

  return (
    <BoxBlock design={{ box: design.box }} onClick={clicker}>
      <ImageBlock src={src} alt={alt} design={{ image: design.image }} />
      <TextBlock text={text} design={{ text: design.text }} />
    </BoxBlock>
  );
};

export default ImageTextBlock;
